export interface IShopItemDiscount {
  id: number;
  value: number;
  startDate: string;
  endDate: string | null;
  status: string;
  badgeType: string | null;
}

interface IShopItemBase {
  id: number;
  name: string;
  price: string;
  image: string;
  stock: number;
  showStock: boolean;
  isActive: boolean;
  limitPerUser: number;
  multiplier: number;
  expiresAt: string;
  consumed: null | number;
  consumedByMe: number;
  gameId: null | number;
  value: number;
  paidAmount?: string;
  activeDiscount?: IShopItemDiscount;
}

export interface IShopItemResponse extends IShopItemBase {
  category: { name: string };
  token: { id: number; name: string; image: string };
}

export interface IShopItem extends IShopItemBase {
  nameTranslations: Record<string, string>;
  category: {
    name: string;
    translations: Record<string, string>;
  };
  token: {
    id: number;
    name: string;
    image: string;
    translations: Record<string, string>;
  };
}

export type SortIconType = "priceDown" | "priceUp" | "date";
export interface SortOption {
  label: string;
  value: string;
}

export interface IUserBalance {
  balance: string;
  token: {
    id: number;
    name: string;
    image: string;
  };
}
export interface IShopCategoryResponse {
  createdAt: string;
  id: number;
  name: string;
}

export interface IShopCategory extends IShopCategoryResponse {
  translations: Record<string, string>;
}

export interface IShopFilters {
  categoryId: null | number;
  tokenId: null | number;
  sortBy: null | string;
  search: string;
  priceRange: {
    min: number;
    max: number;
  } | null;
}

export enum ShopSortOptionEnum {
  PRICE_ASC = "price_asc",
  PRICE_DESC = "price_desc",
  DATE_ASC = "date_asc",
  DATE_DESC = "date_desc",
  CAN_PURCHASE = "can_purchase",
}

export enum ShopItemStatusEnum {
  IDLE = "idle",
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  PENDING = "pending",
}

export type ShopItemStatus = "idle" | "loading" | "pending" | "success" | "error";

export enum PurchaseStatusEnum {
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
  PENDING = "PENDING",
}

type ShopHistoryItemBase = {
  createdAt: string;
  id: number;
  status: "FAILED" | "SUCCESS" | "PENDING";
  transactionId: number;
};

export interface IShopHistoryItemResponse extends ShopHistoryItemBase {
  item: IShopItemResponse;
}

export interface IShopHistoryItem extends ShopHistoryItemBase {
  item: IShopItem;
  paidAmount: string;
}

export enum ShopPurchaseErrorStatusEnum {
  DEFAULT_ERROR_CODE = "2",
  PURCHASE_LIMIT_REACHED = "4",
  DISCOUNT_INVALID = "6",
}
